// extracted by mini-css-extract-plugin
export default {"wrapper":"LeadsForm_wrapper__niCWX","buttonContainer":"LeadsForm_buttonContainer__ZhTnd"};